import { EmailVerificationAccountSetupState } from "./EmailVerificationAccountSetupState";
import { EmailVerificationInitialState } from "./EmailVerificationInitialState";
import { EmailVerificationOTPState } from "./EmailVerificationOTPState";
import { EmailVerificationPasswordState } from "./EmailVerificationPasswordState";
import {
  isClaimStep,
  isInitialStep,
  isOTPRequiredStep,
  isPasswordSigninStep,
  isSignupStep,
  isValidatingStep,
} from "./helpers";
import {
  type EmailVerificationStatus,
  type EmailVerificationStep,
} from "./types";

interface EmailVerificationCurrentStateProps {
  displayedStep: EmailVerificationStep;
  handleForgotPasswordSubmit: () => void;
  handleOTPSubmit: (otp: string) => void;
  handlePasswordSubmit: (password: string) => void;
  handleResendOTP: () => void;
  onAuthenticationLinkClick: () => void;
  resetToInitial: () => void;
  showClaimForm: () => void;
  showOTPForm: () => void;
  showPasswordForm: () => void;
  state: {
    isLoading: boolean;
    shouldShowAuthenticationLink: boolean;
    email: string;
    status: EmailVerificationStatus | null;
    isSubmittingOTP: boolean;
    isResendingOTP: boolean;
    error: string | null;
    isSubmittingPassword: boolean;
    isSubmittingForgotPassword: boolean;
  };
}

export const EmailVerificationCurrentState = ({
  displayedStep,
  state,
  onAuthenticationLinkClick,
  resetToInitial,
  showPasswordForm,
  showClaimForm,
  handleOTPSubmit,
  handleResendOTP,
  showOTPForm,
  handlePasswordSubmit,
  handleForgotPasswordSubmit,
}: EmailVerificationCurrentStateProps) => {
  if (isInitialStep(displayedStep) || isValidatingStep(displayedStep)) {
    return (
      <EmailVerificationInitialState
        isValidating={state.isLoading}
        shouldShowAuthenticationLink={state.shouldShowAuthenticationLink}
        onAuthenticationLinkClick={onAuthenticationLinkClick}
      />
    );
  }

  if (isOTPRequiredStep(displayedStep)) {
    return (
      <EmailVerificationOTPState
        email={state.email}
        status={state.status}
        onClose={resetToInitial}
        onShowPasswordForm={showPasswordForm}
        onShowClaimForm={showClaimForm}
        onOTPSubmit={handleOTPSubmit}
        onResendCode={handleResendOTP}
        isSubmitting={state.isSubmittingOTP}
        isResending={state.isResendingOTP}
        error={state.error}
      />
    );
  }

  if (isPasswordSigninStep(displayedStep)) {
    return (
      <EmailVerificationPasswordState
        email={state.email}
        onClose={resetToInitial}
        onShowOTPForm={showOTPForm}
        onPasswordSubmit={handlePasswordSubmit}
        onForgotPasswordSubmit={handleForgotPasswordSubmit}
        isSubmitting={state.isSubmittingPassword}
        isSubmittingForgotPassword={state.isSubmittingForgotPassword}
        error={state.error}
      />
    );
  }

  if (isSignupStep(displayedStep) || isClaimStep(displayedStep)) {
    return (
      <EmailVerificationAccountSetupState
        email={state.email}
        onClose={resetToInitial}
      />
    );
  }

  return null;
};
